import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Real client work — Christina's portfolio
const PLACEHOLDER_IMAGES = [
  { id: 1, url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/i7sccqqp_20260414_154726.jpg', alt: 'Multicolor confetti glitter coffin nails with rhinestones', category: 'Custom Nails' },
  { id: 2, url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/ox3q0o2h_20260414_154732.jpg', alt: 'Pink heart rhinestone & silver glitter coffin nails', category: 'Custom Nails' },
  { id: 3, url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/a1efntw8_Snapchat-1296582830.jpg', alt: 'Blue & silver glitter coffin nails with rhinestones', category: 'Custom Nails' },
  { id: 4, url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/0vurvc5u_Snapchat-1947887472.jpg', alt: 'Blue glitter ombre coffin nails', category: 'Custom Nails' },
  { id: 5, url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/zde6zmvq_6b956bea-9d98-4b4a-bf93-ea0486667267.png', alt: 'Pink ombre glitter stiletto nails', category: 'Gel Nails' },
  { id: 6, url: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=600&q=80', alt: 'Custom luxury spray tan glow', category: 'Spray Tan' },
  { id: 7, url: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?w=600&q=80', alt: 'Pro makeup look', category: 'Makeup' },
  { id: 8, url: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&q=80', alt: 'Glow facial treatment', category: 'Facials' },
  { id: 9, url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80', alt: 'Bridal hair styling', category: 'Hair' },
];

// Real client work videos — embedded
const CLIENT_VIDEOS = [
  { id: 'v1', url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/zvw8x481_Snapchat-1602077005.mp4', label: 'Behind the scenes — nail magic' },
  { id: 'v2', url: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/h0dl2epg_Snapchat-2060804966.mp4', label: 'Client glow-up reveal' },
];

const Gallery = () => {
  return (
    <div className="py-20" data-testid="gallery-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ Our Work ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="gallery-title">
            The <span className="italic text-pink-300">glow</span> portfolio
          </h1>
          <p className="mt-4 text-amber-100/60 max-w-xl mx-auto">
            A few of our favorite transformations. Tag <span className="text-amber-200">@monthlyglowonthego</span> to be featured!
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {PLACEHOLDER_IMAGES.map((img, i) => (
            <motion.div
              key={img.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: (i % 6) * 0.06 }}
              viewport={{ once: true }}
              className="group relative aspect-square overflow-hidden rounded-xl border border-amber-700/30 bg-black/40"
              data-testid={`gallery-item-${img.id}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-[10px] tracking-[0.3em] uppercase text-amber-200">{img.category}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Behind the scenes videos */}
        <div className="mt-20">
          <div className="text-center mb-8">
            <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-3">✦ Watch The Magic ✦</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-amber-50">Behind the <span className="italic text-pink-300">glow</span></h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {CLIENT_VIDEOS.map(v => (
              <div key={v.id} className="rounded-xl overflow-hidden border border-amber-700/30 bg-black/40" data-testid={`video-${v.id}`}>
                <video
                  src={v.url}
                  controls
                  playsInline
                  preload="metadata"
                  className="w-full aspect-video bg-black"
                />
                <div className="px-4 py-3 text-sm text-amber-100/80 italic">{v.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <Link to="/book" className="inline-block px-10 py-4 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all" data-testid="gallery-cta">
            Book Your Glow
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
